<button class="ProfilPicture" type="button" name="button" [class.border]="!src" (click)="click($event)" [style.height.px]="size" [style.width.px]="size" [disabled]="disabled">
  <img *ngIf="src" class="ProfilPicture-img" src="{{src}}" alt="{{alt}}" (error)="onError()">
  <def-sprites *ngIf="!src" color="disabled" width="100%" height="100%" sprite="account"></def-sprites>
</button>
